import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Lenis from 'lenis';
import './App.css';
import Home from './pages/Home';
import ProjectDetail from './pages/ProjectDetail';
import PhotographyDetail from './pages/PhotographyDetail';
import DressCodesProject from './pages/DressCodesProject';
import FutureObservatoryProject from './pages/FutureObservatoryProject';
import PrincesInTowerProject from './pages/PrincesInTowerProject';
import TreasuredResistanceProject from './pages/TreasuredResistanceProject';
import ChildrenOfLeaProject from './pages/ChildrenOfLeaProject';
import PortraitsProject from './pages/PortraitsProject';
import WomCollectiveProject from './pages/WomCollectiveProject';
import Header from './components/Header';

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-cream text-dark min-h-screen">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/photography/:id" element={<PhotographyDetail />} />
          <Route path="/project/dress-codes" element={<DressCodesProject />} />
          <Route path="/project/future-observatory" element={<FutureObservatoryProject />} />
          <Route path="/project/princes-in-tower" element={<PrincesInTowerProject />} />
          <Route path="/photography/waste-workers-bahia" element={<TreasuredResistanceProject />} />
          <Route path="/photography/children-of-lea" element={<ChildrenOfLeaProject />} />
          <Route path="/photography/portraits" element={<PortraitsProject />} />
          <Route path="/photography/wom-collective" element={<WomCollectiveProject />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
